import { Logo } from '@/components/brand/Logo';

/**
 * Pitch footer. Minimal, confident, no marketing surface.
 *
 * Brand lockup left, deep-links right (ROI model + back to top). No
 * "contact us" form by design — investor route is by warm intro, not a
 * public form.
 */
export function PitchFooter() {
  return (
    <footer className="relative border-t border-border bg-bg-page">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6 py-12 sm:flex-row sm:items-center sm:justify-between sm:px-10 sm:py-14">
        <div className="flex items-center gap-4">
          <Logo size="sm" />
          <span className="hidden text-[12px] text-ink-dim sm:inline">
            Confidence through intelligence
          </span>
        </div>

        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-[12px] font-medium uppercase tracking-[0.16em] text-ink-muted">
          <a href="/roi" className="transition-colors hover:text-ink-strong">
            ROI model
          </a>
          <a
            href="/roi#market"
            className="transition-colors hover:text-ink-strong"
          >
            UK market
          </a>
          <a
            href="/roi#international"
            className="transition-colors hover:text-ink-strong"
          >
            International
          </a>
          <a href="#hero" className="transition-colors hover:text-ink-strong">
            ↑ Top
          </a>
        </nav>
      </div>

      <div className="border-t border-border-subtle">
        <div className="mx-auto flex max-w-6xl px-6 py-5 text-[11px] leading-relaxed text-ink-dim sm:px-10">
          <p className="max-w-3xl">
            This run through is for investors and contains forward looking
            statements. Figures are illustrative; full assumptions live on the
            ROI page. Asset Hound operates in a regulated industry; all AI
            output is human approved before it leaves the system
          </p>
        </div>
      </div>
    </footer>
  );
}
